// removed by extract-text-webpack-plugin
module.exports = {"pad":"pad___P6ndh","empty":"empty___1Uq-y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Pad/index.scss
// module id = 99
// module chunks = 0